import React from 'react'
import { PreviousMatchupInfo } from '../../../../Api'
import { Percent } from '../../../../Utils/formatting'
import { getShortDateWithYear } from '../../../../Utils/formatting'
import { MatchupStyle, StatConStyle, TeamStatHeader } from './styles'
import { Header } from './Header'
import { colors } from '../../../../Components/consts'

type TeamComparisonProps = {
  matchupInfo: PreviousMatchupInfo
}

export const TeamComparison: React.FC<React.PropsWithChildren<TeamComparisonProps>> = ({
  matchupInfo,
}) => {
  const team1 = matchupInfo.awayTeam
  const team2 = matchupInfo.homeTeam

  return (
    <>
      {matchupInfo && (
        <>
          <MatchupStyle>
            <div className="date">
              <p>
                Week {matchupInfo.week} | {getShortDateWithYear(matchupInfo.startTime)}
              </p>
            </div>
            <Header awayTeamId={team1.officialId} homeTeamId={team2.officialId} />
            <StatConStyle>
              <TeamStatHeader teamColor={colors.white}>{team1.scores}</TeamStatHeader>
              <div className="statName"> Final </div>
              <TeamStatHeader teamColor={colors.white}>{team2.scores}</TeamStatHeader>
            </StatConStyle>
            <StatConStyle>
              <TeamStatHeader teamColor={colors.white}>
                {Percent(team1.shotPct)}
              </TeamStatHeader>
              <div className="statName"> Shot %</div>
              <TeamStatHeader teamColor={colors.white}>
                {Percent(team2.shotPct)}
              </TeamStatHeader>
            </StatConStyle>
            <StatConStyle>
              <TeamStatHeader teamColor={colors.white}>
                {Percent(team1.faceoffPct)}
              </TeamStatHeader>
              <div className="statName"> Faceoff %</div>
              <TeamStatHeader teamColor={colors.white}>
                {Percent(team2.faceoffPct)}
              </TeamStatHeader>
            </StatConStyle>
            <StatConStyle>
              <TeamStatHeader teamColor={colors.white}>
                {Percent(team1.savePct)}
              </TeamStatHeader>
              <div className="statName"> Save %</div>
              <TeamStatHeader teamColor={colors.white}>
                {Percent(team2.savePct)}
              </TeamStatHeader>
            </StatConStyle>
          </MatchupStyle>
        </>
      )}
    </>
  )
}
